/**
 * wap广告
 * 需要配合广告发布系统 例如 http://cp.eastmoney.com/wap/37.js
 */

require('./ad.css');

var ad = (function() {
    function ad(options) {
        var defaultopions = {
            source: 'http://cp.eastmoney.com/wap/37.js', //广告来源
            type: 'pagetop' //广告类型 pagetop 页面顶部广告(不固顶) pagebuttom_fix 页面底部(固底)

        }
        this.options = $.extend(defaultopions, options);
        this.options.adname = getAdName(this.options.source);
    }

    function getV() {
        var _D = new Date();
        var _m = Math.round(_D.getMinutes()/5)*5;
        return _D.getFullYear() + "" + (_D.getMonth() + 1) + _D.getDate() + _D.getHours() + _m;
    }

    ///显示广告
    ad.prototype.show = function () {
        var _this = this;
        $.ajax({
            url: '/Extends/GetReferralLinkJavaScriptObj',
            type: 'POST',
            dataType:'json',
        	cache: true,
            data: {url:_this.options.source+'?v='+getV() }
        })
        .done(function (data) {
            if (data) {
                //if (window[_this.options.adname] != undefined) {
                if(data){
                    var _adObj = data[parseInt(Math.random() * data.length)];;//window[_this.options.adname];
                    var dUrl = _adObj.android;
                    if (/(iPhone|iPod|iPad|iTouch|iOS)/i.test(navigator.userAgent)) {
                        dUrl = _adObj.ios;
                    }
                    else if (/Android/i.test(navigator.userAgent)) {
                        dUrl = _adObj.android;
                    }
                    else {
                        return false;
                    }

                    if (_this.options.type == "pagetop") {
                        var html = $('<div class="wapimportant_pagetop"><a href="' + dUrl + '"><img src="' + _adObj.img + "?v=" + getV() + '"></a><span class="close"></span></div>');

                        $('img', html).error(function () {
                            html.remove();
                        });

                        html.on('click', '.close', function () {
                            html.remove();
                        });

                        $('body').prepend(html);
                    }
                    else if (_this.options.type == "pagebuttom_fix") {
                        var html = $('<div class="wapimportant_pagebuttom_fix"><a href="' + dUrl + '"><img src="' + _adObj.img + "?v=" + getV() + '"></a><span class="close"></span></div>');

                        $('img', html).error(function () {
                            html.remove();
                        });

                        $('img', html).on("load", function () { //底部留白
                            $('body').css('padding-bottom', parseInt($('body').css('padding-bottom')) + $(this).height());
                        });

                        html.on('click', '.close', function () {
                            $('body').css('padding-bottom', parseInt($('body').css('padding-bottom')) - $(this).height());
                            html.remove();

                        });

                        $('body').prepend(html);
                    }
                }
            }
            return false;        	
        });

    };

    //根据广告地址获取广告变量名称
    function getAdName(source) {
        return 'wapad' + source.match(/\d+/);
    }

    return ad;
})();

module.exports = ad;



//////////////////
// WEBPACK FOOTER
// ./dev/modules/ad/ad.js
// module id = 1
// module chunks = 0 5 6 7 8 9 10 12 14 15 16 17 19